import { createSlice } from "@reduxjs/toolkit";






export const ReservationSlice = createSlice({
    name: 'Reservation',
    initialState: {
        loading: true,
        oldReservation:[],
        newReservation:[]

    },
    reducers: {
        setNewReservationReducer: (state, action) => {
            state.newReservation = action.payload;
        },

        emptyNewReservationReducer: (state) => {
            state.newReservation = [];
        },
        
    },
   
})

export const { setNewReservationReducer, emptyNewReservationReducer } = ReservationSlice.actions;



export const ReservationReducer = ReservationSlice.reducer